<template>
  <el-row
    type="flex"
    justify="space-between"
    align="middle"
  >
    <div>
      <h1 class="card-container__title">{{ title }}</h1>
      <p class="card-container__subtitle">Tổng số: {{ total }}</p>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        :disabled="disabled"
        :plain="plain"
        @click="$emit('create')"
        >Thêm mới</el-button
      >
      <el-button
        class="ml-s"
        type="primary"
        size="small"
        icon="el-icon-refresh"
        :plain="plain"
        :disabled="disabled"
        @click="$emit('refresh')"
        >Làm mới</el-button
      >
      <el-button
        size="small"
        icon="el-icon-download"
        class="ml-s"
        :disabled="disabled || allConfigs.length === 0"
        :loading="exporting"
        @click="exportJson"
      >
        <span>Export</span>
      </el-button>
      <el-upload
        class="file-uploader ml-s"
        action
        :accept="`.json`"
        :show-file-list="false"
        :http-request="uploadFiles"
        :disabled="allConfigs.length > 0"
      >
        <el-button
          size="small"
          icon="el-icon-upload2"
          :loading="importing"
          :disabled="disabled || allConfigs.length > 0"
        >
          <span>Import</span>
        </el-button>
      </el-upload>
    </el-row>
  </el-row>
</template>

<script>
import { mapGetters } from "vuex";
import { JSONToFile, notification } from "@/utils/common";
import configServices from "@/services/config";

export default {
  name: "CardHeader",
  props: {
    title: String,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
    allConfigs: Array
  },
  data() {
    return {
      exporting: false,
      importing: false
    }
  },
  computed: {
    ...mapGetters("organization", ["selectedOrg"]),
    params() {
      const _params = {
        offset: 0,
        limit: 999,
        locale: "vi",
        sort: "-created",
        filters: {
          "extra.organization_id": this.selectedOrg.id
        }
      };
      return _params;
    },
  },
  methods: {
    async exportJson() {
      this.exporting = true;
      const exportData = this.allConfigs.map((c) => ({
        ...c,
        extra: {
          ...c.extra,
          is_publish: false,
          modules: (c.extra.modules || []).map((m) => ({ ...m, roles: [] })),
          contracts: []
        }
      }))
      JSONToFile(exportData, this.title);
      this.$notify.success({
        title: "Thông báo !",
        message: "Lưu file JSON thành công !",
      });
      this.exporting = false;
    },
    async uploadFiles(fileInfo) {
      const file = fileInfo.file;
      this.importing = true;
      const reader = new FileReader();
      const self = this;
      reader.onload = async function (e) {
        const data = e.target.result;
        const jsonData = JSON.parse(data);
        await self.importData(jsonData || [])
        self.importing = false;
      };

      reader.onerror = function (ex) {
        console.log(ex);
      };

      reader.readAsText(file);
    },

    async importData(jsonData) {
      const requests = [];
      if (jsonData.length > 0) {
        jsonData.forEach(data => {
          delete data.id;
          requests.push(
            configServices.create({
              ...data,
              extra: {
                ...data.extra,
                organization_id: this.selectedOrg.id
              }
            })
          )
        });
        Promise.all(requests).then(() => {
          notification(
            this,
            "success",
            "create",
            "cấu hình cho tổ chức"
          );
          this.$emit("refresh");
        }).catch(() => {
          notification(
            this,
            "error",
            "create",
            "cấu hình cho tổ chức"
          );
        })
      }
    }
  },
};
</script>

<style lang="scss" scoped></style>
